// Flat translation dictionary. Add a key here, get a compile error in any unfinished caller.
// Placeholders use {name} syntax: t('foo', { name: 'bar' }).
//
// Deutsch ist die Default-Sprache (siehe BILLING_PLAN.md §13); Englisch ist vorbereitet, aber
// noch nicht an einen Sprachschalter angebunden (P3.3 laut Plan). Texte für die Baseline-Seiten
// stammen aus §13.

export const messages = {
  // Navigation / shell
  'nav.instances': { de: 'Instanzen', en: 'Instances' },
  'nav.help': { de: 'Hilfe', en: 'Help' },
  'nav.signOut': { de: 'Abmelden', en: 'Sign out' },

  'generic.loading': { de: 'Lädt…', en: 'Loading…' },
  'generic.cancel': { de: 'Abbrechen', en: 'Cancel' },
  'generic.save': { de: 'Speichern', en: 'Save' },
  'generic.close': { de: 'Schließen', en: 'Close' },
  'generic.back': { de: 'Zurück', en: 'Back' },
  'generic.retry': { de: 'Erneut versuchen', en: 'Retry' },
  'generic.error': { de: 'Etwas ist schiefgelaufen.', en: 'Something went wrong.' },

  // Login
  'login.title': { de: 'Bei Clockoo anmelden', en: 'Sign in to Clockoo' },
  'login.subtitle': {
    de: 'Anmeldung mit Passkey oder Einmal-Code.',
    en: 'Sign in with your passkey or one-time code.',
  },
  'login.hankoMissing': {
    de: 'Authentifizierungs-Endpunkt ist nicht konfiguriert.',
    en: 'Authentication endpoint is not configured.',
  },
  'login.brandedBy': { de: 'Clockoo · Zeiterfassung für Odoo', en: 'Clockoo · Time tracking for Odoo' },

  // Instances — list (route: /instances)
  'instances.title': { de: 'Deine Instanzen', en: 'Your instances' },
  'instances.subtitle': {
    de: 'Odoo-Instanzen, Lizenzstatus und Seat-Nutzung.',
    en: 'Odoo instances, license status, and seat usage.',
  },
  'instances.empty': {
    de: 'Noch keine Instanz registriert.',
    en: 'No instance registered yet.',
  },
  'instances.loadError': {
    de: 'Instanzen konnten nicht geladen werden.',
    en: 'Could not load instances.',
  },
  'instances.add': { de: 'Instanz registrieren', en: 'Register instance' },
  'instances.seatModelBanner': {
    de: 'Ein Seat = ein aktiver Nutzer in den letzten 30 Tagen. Inaktive Seats werden automatisch frei.',
    en: 'One seat = one active user in the last 30 days. Inactive seats free up automatically.',
  },
  'instances.seatsUsage': { de: '{active} von {purchased} Seats belegt', en: '{active} of {purchased} seats in use' },
  'instances.trialSeatsUsage': { de: '{active} aktive Nutzer im Trial', en: '{active} active users in trial' },
  'instances.card.buySeats': { de: 'Seats kaufen', en: 'Buy seats' },
  'instances.card.manageSubscription': { de: 'Abo verwalten', en: 'Manage subscription' },
  'instances.card.unpinned': { de: 'ungepinnt', en: 'unpinned' },

  // Status badge
  'status.trial': { de: 'Trial · noch {days} Tage', en: 'Trial · {days} days left' },
  'status.active': { de: 'Aktiv', en: 'Active' },
  'status.pastDue': { de: 'Zahlung offen', en: 'Payment overdue' },
  'status.canceled': { de: 'Gekündigt', en: 'Canceled' },
  'status.blocked': { de: 'Gesperrt', en: 'Blocked' },

  // Instances — new (route: /instances/new)
  'instances.new.title': { de: 'Neue Instanz registrieren', en: 'Register a new instance' },
  'instances.new.subtitle': {
    de: 'Startet 14 Tage kostenlosen Trial für diese Odoo-Instanz.',
    en: 'Starts a 14-day free trial for this Odoo instance.',
  },
  'instances.new.nameLabel': { de: 'Name / Titel', en: 'Name / title' },
  'instances.new.namePlaceholder': { de: 'z. B. Meine Firma GmbH', en: 'e.g. My Company Ltd' },
  'instances.new.nameHint': {
    de: 'Frei wählbar — nur zur Anzeige im Portal.',
    en: 'Free-form — for display in the portal only.',
  },
  'instances.new.urlLabel': { de: 'Odoo-URL', en: 'Odoo URL' },
  'instances.new.urlPlaceholder': { de: 'https://erp.deine-firma.de', en: 'https://erp.your-company.com' },
  'instances.new.urlIdentHint': {
    de: 'Diese URL nutzt die Clockoo-App später zum Lizenzabgleich — sie muss der Adresse entsprechen, mit der sich eure Mitarbeiter mit Odoo verbinden.',
    en: 'The Clockoo app later uses this URL to validate the license — it must match the address your team connects to Odoo with.',
  },
  'instances.new.normalizedPreview': { de: 'Wird registriert als: {value}', en: 'Will be registered as: {value}' },
  'instances.new.submit': { de: 'Trial starten', en: 'Start trial' },
  'instances.new.submitting': { de: 'Wird registriert…', en: 'Registering…' },
  'instances.new.error.identTaken': {
    de: 'Diese URL ist bereits registriert.',
    en: 'This URL is already registered.',
  },
  'instances.new.error.generic': {
    de: 'Registrierung fehlgeschlagen. Bitte versuche es erneut.',
    en: 'Registration failed. Please try again.',
  },

  // Instances — detail (route: /instances/$id)
  'instances.detail.back': { de: 'Zurück zur Übersicht', en: 'Back to overview' },
  'instances.detail.notFound': { de: 'Instanz nicht gefunden.', en: 'Instance not found.' },
  'instances.detail.loadError': {
    de: 'Instanz konnte nicht geladen werden.',
    en: 'Could not load instance.',
  },
  'instances.detail.section.status': { de: 'Status', en: 'Status' },
  'instances.detail.trialEndsAt': { de: 'Trial endet am {date}', en: 'Trial ends on {date}' },
  'instances.detail.graceEndsAt': { de: 'Kulanzfrist bis {date}', en: 'Grace period until {date}' },
  'instances.detail.currentPeriodEnd': { de: 'Laufende Periode bis {date}', en: 'Current period ends {date}' },
  'instances.detail.cancelAtPeriodEnd': {
    de: 'Wird zum Periodenende gekündigt.',
    en: 'Will cancel at the end of the current period.',
  },

  'instances.detail.section.seats': { de: 'Seats', en: 'Seats' },
  'instances.detail.seatsPurchased': { de: 'Gekauft', en: 'Purchased' },
  'instances.detail.seatsActive': { de: 'Aktiv (30 Tage)', en: 'Active (30 days)' },
  'instances.detail.seatsRecommended': { de: 'Empfehlung', en: 'Recommended' },
  'instances.detail.seatList.title': { de: 'Belegte Seats', en: 'Active seats' },
  'instances.detail.seatList.empty': { de: 'Noch keine Seats belegt.', en: 'No seats claimed yet.' },
  'instances.detail.seatList.loadError': {
    de: 'Seats konnten nicht geladen werden.',
    en: 'Could not load seats.',
  },
  'instances.detail.seatList.col.hash': { de: 'Seat (Hash-Präfix)', en: 'Seat (hash prefix)' },
  'instances.detail.seatList.col.firstSeen': { de: 'Erste Nutzung', en: 'First seen' },
  'instances.detail.seatList.col.lastSeen': { de: 'Letzte Nutzung', en: 'Last seen' },
  'instances.detail.seatList.col.appVersion': { de: 'App-Version', en: 'App version' },
  'instances.detail.seatList.col.actions': { de: 'Aktionen', en: 'Actions' },
  'instances.detail.seatList.hint': {
    de: 'Nur Zahlen und anonyme Hash-Präfixe — keine Namen. Namen der Nutzer sieht ausschließlich die Desktop-App (lokal aufgelöst, verlässt das Gerät nie).',
    en: 'Numbers and anonymous hash prefixes only — no names. User names are resolved locally in the desktop app and never leave the device.',
  },
  'instances.detail.actions.releaseSeat': { de: 'Seat freigeben', en: 'Release seat' },
  'instances.detail.actions.resetAll': { de: 'Alle Seats zurücksetzen', en: 'Reset all seats' },
  'instances.detail.actions.resetAllConfirm': {
    de: 'Wirklich alle aktiven Seats freigeben? Jeder Nutzer muss sich beim nächsten Odoo-Login neu einbuchen.',
    en: 'Really release all active seats? Every user will re-claim a seat on their next Odoo login.',
  },

  'instances.detail.section.pinning': { de: 'Instanz-Pinning', en: 'Instance pinning' },
  'instances.detail.pinning.pinned': { de: 'Gepinnt auf Datenbank-UUID {uuid}', en: 'Pinned to database UUID {uuid}' },
  'instances.detail.pinning.unpinned': {
    de: 'Noch nicht gepinnt — der erste Heartbeat mit Companion-Modul pinnt automatisch.',
    en: 'Not pinned yet — the first heartbeat with the companion module pins automatically.',
  },
  'instances.detail.actions.resetPin': { de: 'Pinning zurücksetzen', en: 'Reset pinning' },
  'instances.detail.actions.resetPinWarning': {
    de: 'Nur nach einem DB-Restore oder einer Migration nötig: löst die Bindung an die aktuelle Datenbank-UUID, damit der nächste Heartbeat neu pinnen kann. Nicht verwenden, um ein anderes Abo zu übernehmen.',
    en: 'Only needed after a DB restore or migration: releases the binding to the current database UUID so the next heartbeat can re-pin. Do not use this to take over a different subscription.',
  },
  'instances.detail.actions.resetPinNotApplicable': {
    de: 'Bei UUID-Registrierung nicht anwendbar — bitte Support kontaktieren.',
    en: 'Not applicable for UUID-registered instances — please contact support.',
  },
  'instances.detail.pinning.error': {
    de: 'Pinning konnte nicht zurückgesetzt werden.',
    en: 'Could not reset pinning.',
  },

  'instances.detail.section.billing': { de: 'Abrechnung', en: 'Billing' },
  'instances.detail.actions.buySeats': { de: 'Seats kaufen', en: 'Buy seats' },
  'instances.detail.actions.manageSubscription': { de: 'Abo verwalten', en: 'Manage subscription' },
  'instances.detail.checkout.seatsLabel': { de: 'Anzahl Seats', en: 'Number of seats' },
  'instances.detail.checkout.submit': { de: 'Zur Kasse', en: 'Continue to checkout' },
  'instances.detail.billing.error': {
    de: 'Weiterleitung zu Stripe fehlgeschlagen. Bitte versuche es erneut.',
    en: 'Redirect to Stripe failed. Please try again.',
  },

  'instances.detail.checkoutSuccess.title': { de: 'Zahlung wird bestätigt…', en: 'Confirming payment…' },
  'instances.detail.checkoutSuccess.body': {
    de: 'Stripe hat die Zahlung angenommen. Es dauert einen Moment, bis der Webhook den Status auf „Aktiv" dreht.',
    en: "Stripe accepted the payment. It takes a moment for the webhook to flip the status to Active.",
  },

  'instances.detail.section.download': { de: 'Desktop-App', en: 'Desktop app' },
  'instances.detail.download.body': {
    de: 'Lade die Clockoo-App herunter und verteile sie an dein Team.',
    en: 'Download the Clockoo app and roll it out to your team.',
  },
  'instances.detail.download.mac': { de: 'Download für macOS', en: 'Download for macOS' },
  'instances.detail.download.windows': { de: 'Download für Windows', en: 'Download for Windows' },
} as const;

export type MessageKey = keyof typeof messages;
export type Locale = 'de' | 'en';

export function format(key: MessageKey, locale: Locale, replacements?: Record<string, string | number>): string {
  let template: string = messages[key][locale];
  if (replacements) {
    for (const [k, v] of Object.entries(replacements)) {
      template = template.replaceAll(`{${k}}`, String(v));
    }
  }
  return template;
}
